/** UtilityHolidays — standalone sidebar page for the UtilityAdmin: manage holidays. */
import Layout from "@/components/Layout";
import { PartyPopper } from "lucide-react";
import AdminHolidays from "@/pages/AdminHolidays";

export default function UtilityHolidays() {
  return (
    <Layout>
      <div className="space-y-6" data-testid="utility-holidays-page">
        <div className="flex items-center gap-3">
          <div className="h-11 w-11 rounded-xl bg-amber-50 dark:bg-amber-900/30 text-amber-600 dark:text-amber-300 flex items-center justify-center">
            <PartyPopper className="h-5 w-5" />
          </div>
          <div>
            <h1 className="text-2xl font-semibold text-slate-900 dark:text-slate-100" style={{ fontFamily: "Outfit" }}>Holidays</h1>
            <p className="text-sm text-slate-500 dark:text-slate-400">Add and manage the school holiday calendar.</p>
          </div>
        </div>
        <AdminHolidays embedded />
      </div>
    </Layout>
  );
}
